import React from 'react';
import { FilterTab } from '../types';
import { OptionsIcon, MapIcon, PinIcon } from '../icons';

interface Props {
  activeTab: FilterTab;
  onChange: (tab: FilterTab) => void;
}

const TABS: { key: FilterTab; label: string; Icon: React.FC }[] = [
  { key: 'unvan', label: 'Ünvan üzrə', Icon: PinIcon },
  { key: 'xerite', label: 'Xəritə üzərində', Icon: MapIcon },
  { key: 'parametrler', label: 'Parametrlər üzrə', Icon: OptionsIcon },
];

/* The pill-shaped tab control has one moving "slider" element that
   slides under the active button. The CSS reads `--active-idx` from
   the container's inline style and translates the slider accordingly,
   so switching tabs animates smoothly with a single CSS transition.

   Icons inherit color from the button via `currentColor` (see icons.tsx
   + `.sa-filter__tab` rules). The slider provides the active background
   + shadow on desktop / tablet; on mobile the tabs stack vertically and
   the active background is painted directly on the active button. */
const FilterTabs: React.FC<Props> = ({ activeTab, onChange }) => {
  const activeIdx = Math.max(0, TABS.findIndex((t) => t.key === activeTab));

  return (
    <section>
      <div
        className="sa-filter__tabs"
        style={{ ['--active-idx' as any]: activeIdx }}
      >
        <span className="sa-filter__tabs-slider" aria-hidden />
        {TABS.map(({ key, label, Icon }) => (
          <button
            key={key}
            type="button"
            className={`sa-filter__tab ${activeTab === key ? 'sa-filter__tab--active' : ''}`}
            onClick={() => onChange(key)}
          >
            <Icon />
            <span>{label}</span>
          </button>
        ))}
      </div>
    </section>
  );
};

export default FilterTabs;
